import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home-routing.module';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { TabMenuModule } from 'primeng/tabmenu';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { UserTopBarComponent } from './topbar/user.topbar.component';
import { AppRightPanelComponent } from './rightpanel/app.rightpanel.component';
import { AppUserMenuComponent } from './menu/user.menu.component';
import { CheckboxModule } from 'primeng/checkbox';
import { AppUserMenuitemComponent } from './menu/user.menuitem.component';
import { SitesModule } from 'src/app/modules/sites/sites.module';
import { SupportModule } from 'src/app/modules/support/component/support.module';
import { ScenariosModule } from 'src/app/modules/scenarios/scenarios.module';
import { AppUserMenuButtonComponent } from './menu/user.menubutton.component';
import { PermissionsModule } from 'src/app/modules/permissions/permissions.module';
import { EventsModule } from 'src/app/modules/events/events.module';
import { NotificationMaintenanceDialogComponent } from './components/notification-maintenance-dialog/notification-maintenance.dialog.component';
import { PanelModule } from 'primeng/panel';
import { TranslateModule } from '@ngx-translate/core';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { BadgeModule } from 'primeng/badge';
import { TagModule } from 'primeng/tag';

@NgModule({
    declarations: [
        HomeComponent,
        AppRightPanelComponent,
        AppUserMenuComponent,
        AppUserMenuitemComponent,
        UserTopBarComponent,
        AppUserMenuButtonComponent,
        NotificationMaintenanceDialogComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        HomeRoutingModule,
        SharedModule,
        ReactiveFormsModule,
        TabMenuModule,
        ButtonModule,
        MenuModule,
        CheckboxModule,
        FormsModule,
        SitesModule,
        SupportModule,
        ScenariosModule,
        PermissionsModule,
        EventsModule,
        TranslateModule,
        PanelModule,
        ToggleButtonModule,
        BadgeModule,
        TagModule
    ]
})
export class HomeModule { }
